var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9729_9575)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100 0H0V100H100V0ZM14.0897 21.7394C18.3145 21.7394 21.7394 18.3145 21.7394 14.0897C21.7394 9.86489 18.3145 6.44 14.0897 6.44C9.86489 6.44 6.44 9.86489 6.44 14.0897C6.44 18.3145 9.86489 21.7394 14.0897 21.7394ZM9.7193 13.9221C9.7193 13.9221 13.5086 12.3101 14.8227 11.7424C15.3265 11.5154 17.035 10.7888 17.035 10.7888C17.035 10.7888 17.8235 10.4709 17.7578 11.2429C17.742 11.4725 17.6462 12.1165 17.5282 12.9098L17.5281 12.9103C17.4828 13.2154 17.4341 13.5426 17.3854 13.8767C17.1226 15.5797 16.8379 17.4415 16.8379 17.4415C16.8379 17.4415 16.794 17.9638 16.4217 18.0546C16.0494 18.1454 15.436 17.7367 15.3265 17.6459C15.3075 17.6311 15.2196 17.5716 15.0878 17.4823L15.0873 17.4819L15.0873 17.4819C14.6104 17.1589 13.5602 16.4476 13.1143 16.0565C12.961 15.9202 12.7858 15.6478 13.1362 15.3299C13.9247 14.5806 14.8666 13.6497 15.436 13.0594C15.6989 12.7869 15.9617 12.1511 14.8666 12.9231C13.3114 14.0357 11.7782 15.0801 11.7782 15.0801C11.7782 15.0801 11.4277 15.3072 10.7707 15.1028C10.1135 14.8985 9.34692 14.626 9.34692 14.626C9.34692 14.626 8.82127 14.2854 9.7193 13.9221Z",
    fill: "#34AADF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9729_9575"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.0d36736b57dfb46515aad3c3cd0b669f.svg";
export { ForwardRef as ReactComponent };